<div class="tw-w-full tw-p-6 tw-pb-10 tw-relative">
  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-5 tw-right-5 tw-p-1 tw-rounded-full" (click)="closeBottomSheet()">
    <div class="tw-text-black tw-font-bold tw-flex tw-items-center tw-justify-center" style="font-size: 16px; line-height: 1;">&#10005;</div>
  </div>
  <div class="tw-w-[210px] tw-h-[156px] tw-mt-6 tw-mx-auto tw-mb-2">
    <img src="/assets/gifs/skin_report_progress.gif" alt="skin_report_progress" />
  </div>
  <h2 class="tw-font-lexend tw-text-650 tw-leading-[26px] tw-font-bold tw-tracking-normal tw-text-black tw-text-center">
    <span class="tw-capitalize">{{data.userFirstName}}, </span>
    @if (data.privateMainConcernClass === ApiClientConstant.Regimen.Class.HAIR) {
      <span i18n="@@weHaveCreatedYourHairReport">We have <br/> created your hair report</span>
    } @else {
      <span i18n="@@weHaveCreatedYourSkinReport">We have <br/> created your skin report</span>
    }
  </h2>
  @if (data.privateMainConcernClass === ApiClientConstant.Regimen.Class.HAIR) {
    <p class="tw-text-300 tw-font-body tw-tracking-normal tw-text-gray-500 tw-mt-2 tw-text-center" i18n="@@youCanAnswerTheseLastFewOptionalQuestionsHair">You can answer these last few optional questions or jump right in to see your hair report & treatment kit</p>
  } @else {
    <p class="tw-text-300 tw-font-body tw-tracking-normal tw-text-gray-500 tw-mt-2 tw-text-center" i18n="@@youCanAnswerTheseLastFewOptionalQuestionsFace">You can answer these last few optional questions or jump right in to see your skin report & treatment kit</p>
  }
  <div class="tw-mt-10">
    <button csButton
          id="submit-default-answers-sheet-view-report"
          class="tw-w-full tw-text-500 tw-font-semibold tw-tracking-normal tw-capitalize"
          [loading]="isLoading()"
          [disabled]="isLoading()"
          (click)="handleViewReportClick()">
      <span i18n="@@viewReport">View Report</span>
    </button>
    <button csButton="muted"
            id="submit-default-answers-sheet-complete-consultation"
            class="tw-w-full tw-text-500 tw-font-semibold tw-tracking-normal tw-capitalize"
            [disabled]="isLoading()"
            (click)="handleCompleteConsultationClick()">
      <span i18n="@@completeChat">Complete Chat</span>
    </button>
  </div>
</div>

